(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            function initLastReviewsWidget() {
                if (typeof Swiper === 'undefined') {
                    return;
                }

                var swipers = document.querySelectorAll('.js-latest-reviews-swiper');
                if (!swipers.length) {
                    return;
                }

                Array.prototype.forEach.call(swipers, function (swiperElement) {
                    if (swiperElement.dataset.inited === '1') {
                        return;
                    }

                    var swiper = new Swiper(swiperElement, {
                        direction: 'horizontal',
                        spaceBetween: 12,
                        slidesPerView: 3,
                        grabCursor: true,
                        watchOverflow: true,
                        centerInsufficientSlides: true,
                        breakpoints: {
                            0: { slidesPerView: 1.2 },
                            768: { slidesPerView: 2.2 },
                            1024: { slidesPerView: 3 }
                        }
                    });

                    swiperElement.dataset.inited = '1';
                    swiperElement.latestReviewsSwiper = swiper;
                });
            }

            function initLastReviewsNav() {
                document.addEventListener('click', function (event) {
                    var button = event.target.closest('[data-last-reviews-direction]');
                    if (!button) {
                        return;
                    }

                    var widget = button.closest('.latest-reviews-widget');
                    var swiperElement = widget ? widget.querySelector('.js-latest-reviews-swiper') : null;
                    var swiper = swiperElement ? swiperElement.latestReviewsSwiper : null;
                    if (!swiper) {
                        return;
                    }

                    if (Number(button.dataset.lastReviewsDirection) < 0) {
                        swiper.slidePrev();
                        return;
                    }

                    swiper.slideNext();
                });
            }

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', function () {
                    initLastReviewsWidget();
                    initLastReviewsNav();
                });
            } else {
                initLastReviewsWidget();
                initLastReviewsNav();
            }
        })();
    }, {}] }, {}, [1]);